import Vue from 'vue'
import VueRouter from 'vue-router'
import info from '../views/Info.vue'
import school from '../views/school.vue'
import connect from '../views/connect.vue'

Vue.use(VueRouter)

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

const routes = [{
    path: '/',
    name: 'Home',
    component: (resolve) => require(['../views/Home.vue'], resolve)
  },
  {
    path: '/info',
    name: 'info',
    component: info
  },
  {
    path: '/school',
    name: 'school',
    component: school
  },
  {
    path: '/connect',
    name: 'connect',
    component: connect
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  }
})

export default router
